import { ApexOptions } from "apexcharts"
import { useMemo } from "react"
import ReactApexChart from "react-apexcharts"
import { ApexChartType } from "src/shared/config/DefaultApexOptions"
import { totalOnHoverTooltip } from "../../../chartTooltip"
import { colorMapper } from "src/shared/enums/networkColors"
import { monitorApexOptions } from "../../../chartDateAxis"

export const SpendConversionsByDay = ({ series }: ApexOptions) => {
  const spendConversionsByDayOptions = useMemo<ApexOptions>(
    () =>
      monitorApexOptions(
        {
          yaxis: {
            labels: {
              formatter: function (y) {
                return `$${y.toFixed(0)}`
              },
            },
          },
          colors: colorMapper(series),
          // §4.5: the day's combined total alongside the breakdown.
          tooltip: { shared: true, intersect: false, custom: totalOnHoverTooltip("currency") },
        },
        ApexChartType.bar,
      ),
    [series],
  )
  return (
    <div>
      <ReactApexChart
        options={spendConversionsByDayOptions}
        series={series}
        type="bar"
        height={400}
      />
    </div>
  )
}
